import React from 'react';
// Modules
import { Box, Spinner } from '@chakra-ui/react';

const PageLoading: React.FC = () => (
  <Box alignItems="center" display="flex" h="75vh" justifyContent="center">
    <Spinner color="primary.500" emptyColor="gray.200" speed="1s" size="xl" thickness="4px" />
  </Box>
);

export default PageLoading;
